import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import classNames from 'classnames';
import ActiveTabHighlighter from '../../../utils/activeTabHighlighter';
import {TrackEventName} from '../constants/SegmentEvents';
import {segmentEventTracker} from '../../../utils/SegmentEventTracker';

class QuickNav extends Component {
  get pathname() {
    return this.props.location.pathname;
  }

  urlEqualsTo(currentPath) {
    return ActiveTabHighlighter(this.pathname, currentPath);
  }

  tabClassnames(currentPath) {
    return classNames({'-active': this.urlEqualsTo(currentPath)});
  }

  newCustomer() {
    if (!this.props.user.onboarding) return;
    return (
      !this.props.user.onboarding_finished &&
      !this.props.user.onboarding.old_customer
    );
  }

  trackSegmentClick(text) {
    let eventName;
    switch (text) {
      case 'home':
        eventName = TrackEventName.NAVBAR_HOME_CLICKED;
        break;
      case 'applications':
        eventName = TrackEventName.NAVBAR_APPLICATIONS_CLICKED;
        break;
      case 'new_application':
        eventName = TrackEventName.NAVBAR_APPLY_CLICKED;
        break;
      case 'loan_plans':
        eventName = TrackEventName.NAVBAR_LOANS_CLICKED;
        break;
      case 'account':
        eventName = TrackEventName.NAVBAR_ACCOUNT_CLICKED;
        break;
      default:
        return null;
    }
    segmentEventTracker.trackEvent(eventName);
  }

  render() {
    if (!this.props.user.id || this.newCustomer()) return <Fragment />;

    return (
      <div className="ds-appTabs">
        <nav>
          <ul>
            <li className={this.tabClassnames('/')}>
              <Link
                to={{pathname: '/'}}
                data-testid="mobile-navbar-dashboard"
                onClick={() => this.trackSegmentClick('home')}>
                <i className="materialIcon">home</i>
                <small>Dashboard</small>
              </Link>
            </li>
            <li className={this.tabClassnames('/applications')}>
              <Link
                to={{pathname: '/applications'}}
                data-testid="mobile-navbar-applications"
                onClick={() => this.trackSegmentClick('applications')}>
                <i className="materialIcon">description</i>
                <small>Applications</small>
              </Link>
            </li>
            <li className={this.tabClassnames('/apply-now')}>
              <Link
                to={{pathname: '/apply-now'}}
                data-testid="mobile-apply-now-button"
                onClick={() => this.trackSegmentClick('new_application')}>
                <i className="materialIcon">add_circle</i>
                <small>APPLY NOW</small>
              </Link>
            </li>
            <li className={this.tabClassnames('/loan_plans')}>
              <Link
                to={{pathname: '/loan_plans'}}
                data-testid="mobile-navbar-loan-plans"
                onClick={() => this.trackSegmentClick('loan_plans')}>
                <i className="materialIcon">chrome_reader_mode</i>
                <small>Loans</small>
              </Link>
            </li>
            <li className={this.tabClassnames('/account')}>
              <Link
                to={{pathname: '/account'}}
                data-testid="mobile-account-button"
                onClick={() => this.trackSegmentClick('account')}>
                <i className="materialIcon">account_circle</i>
                <small>Account</small>
              </Link>
            </li>
            <li className={this.tabClassnames('/project-finder')}>
              <Link
                to={{pathname: '/project-finder'}}
                data-testid="mobile-project-finder-button"
                onClick={() => this.trackSegmentClick('project-finder')}>
                <i className="materialIcon">search</i>
                <small>Project Finder</small>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = dispatch => ({
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QuickNav),
);



// WEBPACK FOOTER //
// ./src/features/shared/containers/QuickNav.js